import {useMatch} from 'react-router'
import {useState} from 'react'
import {ChangeStatusModal} from './change-status-modal'
import {CancelAssignmentModal} from './cancel-assignment-modal'
import {Button} from '@components/ui/button'
import {routes} from '@utilities/constants/routes'
import {useTranslation} from '@/translations/i18n'
import {Alert} from '@components/ui/alert'

export const ImpersonateToolbar = () => {
    const {t} = useTranslation()
    const isSettingsPage = useMatch(routes.SETTINGS.handle.fullPath)
    const isAssignmentPage = useMatch(routes.ASSIGNMENT.handle.fullPath)
    const [showStatusModal, setShowStatusModal] = useState(false)
    const [showCancelModal, setShowCancelModal] = useState(false)

    return (
        <>
            <Alert
                sentiment="warning"
                icon="default"
                title={t('admin:impersonate_mode')}
                description={t('commons:admin_alert_text')}
                endSlot={
                    (!!isSettingsPage || !!isAssignmentPage) && (
                        <div className="flex items-center gap-3">
                            {!!isSettingsPage && (
                                <Button variant="secondary" size="sm" onClick={() => setShowStatusModal(true)}>
                                    {t('impersonate_statuses:change_status')}
                                </Button>
                            )}
                            {!!isAssignmentPage && (
                                <Button variant="secondary" size="sm" onClick={() => setShowCancelModal(true)}>
                                    {t('admin:assignment_cancellation:cancel_assignment')}
                                </Button>
                            )}
                        </div>
                    )
                }
            />
            {showStatusModal && <ChangeStatusModal onClose={() => setShowStatusModal(false)} />}
            {showCancelModal && <CancelAssignmentModal onClose={() => setShowCancelModal(false)} />}
        </>
    )
}
